export default __webpack_public_path__ + "static/media/question.16e2521a.svg";